import * as React from "react";
import { getFormatedDuration, useBookService } from "./useBookService";
import {
  BreadcrumbChip,
  Header,
  CategoryAccordion,
  ServiceCard,
} from "app/subframe";

import { Icon } from "@subframe/core";
import classNames from "classnames";
import { ExistingServices } from "./components/existingServices";
import { GenericSkeleton } from "app/components/skeleton/genericSkeleton";
import { format } from "date-fns";
import { preserveUtcTimeToLocal } from "app/utils/formatDate";
import { MetaDescriptor } from "app/metaDescriptor/metaDescriptor";
import {ServiceSelection} from "../serviceSelection/ServiceSelection";

export interface BookServiceProps {}

export const BookService: React.FC<BookServiceProps> = ({}) => {
  const {
    shopProvidedServicesCategories,
    handleServiceClick,
    cart,
    isLoading,
    onRemoveMerchantService,
    navigateToStaff,
    navigateToTime,
    account,
    appointmentGroupToReschedule,
  } = useBookService();

  // if (isLoading) {
  //   return (
  //     <div className="my-4 mobile:pt-0 mobile:pb-0">
  //       <GenericSkeleton />
  //     </div>
  //   );
  // }

  return (
    <>
      <MetaDescriptor
        title={account.name}
        description={account.description}
        link={window.location.href}
      />
      {/*<div className="flex relative h-[95vh] my-4 grow shrink-0  basis-0 flex-col items-center gap-1 rounded-2xl bg-white overflow-auto shadow-md mobile:w-full mobile:grow mobile:shrink-0 mobile:basis-0 mobile:my-0 mobile:rounded-none mobile:pb-4">*/}
      {/*  <Header*/}
      {/*    className="h-auto w-[600px] flex-none mobile:h-auto mobile:w-full mobile:flex-none"*/}
      {/*    image={account.logo}*/}
      {/*    text={account.name}*/}
      {/*    rescheduleFromStartTime={*/}
      {/*      appointmentGroupToReschedule &&*/}
      {/*      format(*/}
      {/*        preserveUtcTimeToLocal(appointmentGroupToReschedule?.startTime),*/}
      {/*        "MMM do 'at' h:mm a"*/}
      {/*      )*/}
      {/*    }*/}
      {/*  />*/}
      {/*  <div className="flex w-[600px] grow shrink-0 basis-0 flex-col items-center gap-4 px-4 pb-20 mobile:w-full mobile:grow mobile:shrink-0 mobile:basis-0 mobile:flex-col mobile:gap-6 mobile:px-2 mobile:py-0">*/}
      {/*    <div className="flex w-full items-center justify-between">*/}
      {/*      <BreadcrumbChip text="Service" selected={true} />*/}
      {/*      <Icon*/}
      {/*        className="text-body font-body text-default-font"*/}
      {/*        name="FeatherChevronRight"*/}
      {/*      />*/}
      {/*      <BreadcrumbChip*/}
      {/*        text="Staff"*/}
      {/*        onClick={() => navigateToStaff()}*/}
      {/*        disabled={*/}
      {/*          !cart.merchantServices || cart.merchantServices.length === 0*/}
      {/*        }*/}
      {/*      />*/}
      {/*      <Icon*/}
      {/*        className="text-body font-body text-default-font"*/}
      {/*        name="FeatherChevronRight"*/}
      {/*      />*/}
      {/*      <BreadcrumbChip*/}
      {/*        text="Time"*/}
      {/*        onClick={() => navigateToTime()}*/}
      {/*        disabled={*/}
      {/*          !cart.merchantServices || cart.merchantServices.length === 0*/}
      {/*        }*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*    {cart?.merchantServices?.length > 0 && (*/}
      {/*      <ExistingServices*/}
      {/*        cart={cart}*/}
      {/*        onRemoveMerchantService={onRemoveMerchantService}*/}
      {/*        navigateToTime={navigateToTime}*/}
      {/*      />*/}
      {/*    )}*/}
      {/*    <div className="flex w-full flex-col items-center gap-2">*/}
      {/*      {shopProvidedServicesCategories.map((category: any, index: any) => (*/}
      {/*        <CategoryAccordion*/}
      {/*          text={category.name}*/}
      {/*          key={category.id}*/}
      {/*          defaultOpen={index === 0}*/}
      {/*        >*/}
      {/*          {category.services.map((service: any, index: number) => (*/}
      {/*            <ServiceCard*/}
      {/*              key={service.id}*/}
      {/*              text={service.title}*/}
      {/*              text2={getFormatedDuration(service.duration)}*/}
      {/*              text3={service.price}*/}
      {/*              className={classNames("border-x-1 border-b-1", {*/}
      {/*                "border-t-1": index === 0,*/}
      {/*                "border-t-0": index !== 0,*/}
      {/*                "rounded-b-lg": index === category.services.length - 1,*/}
      {/*                "opacity-50 hover:!bg-transparent cursor-default":*/}
      {/*                  service.selected,*/}
      {/*              })}*/}
      {/*              onClick={() =>*/}
      {/*                !service.selected && handleServiceClick(service)*/}
      {/*              }*/}
      {/*            />*/}
      {/*          ))}*/}
      {/*        </CategoryAccordion>*/}
      {/*      ))}*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}



      <ServiceSelection onBack={()=>{}} onServiceSelect={(service)=>{}}/>


    </>
  );
};
